import styled from 'styled-components';

export const Comments = styled.div`&&&{
  flex-grow: 1;
  position: relative;
  overflow: auto;
  padding-bottom: 14px;
  
  table thead tr th, tr.no-hover td {
    padding-right: 7px;
    padding-left: 7px;
  }
  
  .center {
    text-align: center;
  }
    
  .no-hover {
    background: #fff !important;
    
  }
  
  .merge-down {
    border-bottom: none !important;
  }
  
  .merge-up {
    border: none !important;
  }
  
  .no-wrap {
    white-space: nowrap;
  }
  
  .hide {
    display: none;
  }
  
}`;




// WEBPACK FOOTER //
// ./src/pages/Observations/components/ObservationComments/style.js